import Raven from 'raven-js';
import store from 'store';
import {supported} from 'utils/supported';
import {PRODUCTION} from 'utils/env';

if (PRODUCTION && supported) {
  const raven = Raven.config(RAVEN_PUBLIC_DSN);  // eslint-disable-line no-undef
  let lastUnhandledErrorSize = 0;

  if (LOG_UNCAUGHT_JAVASCRIPT_ERRORS) {  // eslint-disable-line no-undef
    raven.install();
  }

  store.subscribe(() => {
    const unhandledError = store.getState().unhandledError;

    if (lastUnhandledErrorSize !== unhandledError.size) {
      const lastUnhandledError = unhandledError.last();

      if (typeof lastUnhandledError === 'string') {
        raven.captureMessage(lastUnhandledError);
      } else {
        raven.captureException(lastUnhandledError);
      }

      lastUnhandledErrorSize = unhandledError.size;
    }
  });
}



// WEBPACK FOOTER //
// ./app/javascript/initializers/logging.js